/**
 * plugins/vuetify.ts
 *
 * Framework documentation: https://vuetifyjs.com`
 */

// Styles
import 'vuetify/styles'
import { VBtn, VIconBtn } from 'vuetify/components'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import { fa } from 'vuetify/iconsets/fa-svg'
import * as labsComponents from 'vuetify/labs/components'
import { de, en, fr, it } from 'vuetify/locale'
import { config, themes } from '@deepcloud/deep-ui-lib'

// https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
export default config.createVuetifyConfig({
  components: {
    ...components,
    ...labsComponents,
  },
  directives,
  locale: {
    messages: {
      de,
      en,
      fr,
      it,
    },
    locale: import.meta.env.VITE_I18N_LOCALE.split('-')[0],
  },
  date: {
    locale: {
      de: 'de-CH',
      en: 'en-CH',
      fr: 'fr-CH',
      it: 'it-CH',
    },
  },
  icons: {
    aliases: {
      clear: 'far fa-xmark',
      close: 'far fa-xmark',
    },
    sets: {
      fa,
    },
  },

  theme: {
    defaultTheme: 'light',
    themes: {
      light: {
        ...themes.deepBoxLight,
        colors: {
          ...themes.deepNinjaLight.colors,
          ...themes.hoopLight.colors,
          ...themes.deepPortalLight.colors,
          ...themes.deepSignLight.colors,
          ...themes.deepVLight.colors,
          ...themes.deepBoxLight.colors,
          'background-grey': '#F4F4F5',
        },
        variables: {
          'disabled-opacity': 0.7,
        },
      },
      dark: {
        ...themes.deepBoxDark,
        colors: {
          ...themes.deepNinjaDark.colors,
          ...themes.hoopDark.colors,
          ...themes.deepPortalDark.colors,
          ...themes.deepSignDark.colors,
          ...themes.deepVDark.colors,
          ...themes.deepBoxDark.colors,
          'background-grey': '#121212',
        },
        variables: {
          'disabled-opacity': 0.7,
        },
      },
    },
  },
  aliases: {
    VBtnBoxActions: VBtn,
    VBtnBoxActionsIcon: VBtn,
    VBtnToolbar: VIconBtn,
  },
  defaults: {
    VBtnToolbar: {
      class: 'rounded border bg-surface',
      variant: 'outlined',
      iconSize: 18,
      size: 36,
    },
    // Alias
    VBtnBoxActions: {
      class: 'rounded-lg text-black font-weight-regular',
      variant: 'outlined',
      color: 'grey-lighten-3',
      VIcon: {
        color: 'grey',
      },
    },
    VBtnBoxActionsIcon: {
      class: 'rounded-lg text-black font-weight-regular',
      variant: 'outlined',
      color: 'grey-lighten-3',
      size: 34,
      icon: true,
      VIcon: {
        color: 'grey',
      },
    },

    // Vuetify Components
    VBtn: {
      variant: 'flat',
      color: undefined,
    },
    VIcon: {
      size: 18,
    },
    VMenu: {
      VCard: {
        rounded: 'lg',
      },
      VList: {
        rounded: 'lg',
      },
    },
    VNumberInput: {
      variant: 'outlined',
      color: 'primary',
    },
    VTextField: {
      variant: 'outlined',
      color: 'primary',
    },
    VTextarea: {
      variant: 'outlined',
      color: 'primary',
    },
    VSelect: {
      variant: 'outlined',
      color: 'primary',
      itemColor: 'primary',
    },
    VAutocomplete: {
      variant: 'outlined',
      color: 'primary',
      itemColor: 'primary',
      menuProps: {
        contentClass: 'rounded-lg',
      },
    },
    VCombobox: {
      color: 'primary',
      itemColor: 'primary',
      menuProps: {
        contentClass: 'rounded-lg',
      },
    },
    VStepperItem: {
      editIcon: 'far fa-pencil',
    },
    VDataTableServer: {
      VSelectionControl: {
        color: 'primary',
      },
    },
    VCheckbox: {
      color: 'primary',
    },
    VAvatar: {
      color: 'transparent',
    },
  },
})
